function initReviews() {
  if (typeof window.ratingSnippet !== "function") {
    setTimeout(initReviews, 300);
    return;
  }

  const htmlLang =
    document.documentElement.lang ||
    document.body.getAttribute("data-lang") ||
    "en";
  const lang = htmlLang.slice(0, 2);

  const body = document.body;
  const textReviews = body.dataset.textReviews || "Reviews";
  const textReview = body.dataset.textReview || "Review";

  const nodes = document.querySelectorAll(".ruk_rating_snippet");
  if (!nodes.length) return;

  nodes.forEach((el) => {
    if (el.dataset.initialized) return;
    el.dataset.initialized = "true";

    window.ratingSnippet("ruk_rating_snippet", {
      store: "myfruits.eu",
      mode: "default",
      color: "#92A692",
      linebreak: false,
      text: textReviews,
      singularText: textReview,
      lang: lang,
      usePolaris: true,
      showEmptyStars: false,
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initReviews);
} else {
  initReviews();
}

document.addEventListener("shopify:section:load", initReviews);
document.addEventListener("product-recommendations:loaded", initReviews);
document.addEventListener('cart-recommendations:loaded', initReviews);

(function observeRecommendations() {
  const pr = document.querySelector("product-recommendations");
  if (!pr) return;
  initReviews();
  const prObserver = new MutationObserver(() => {
    initReviews();
  });
  prObserver.observe(pr, { childList: true, subtree: true });
})();

// Observe Flow theme recommendations (cart & product)
(function observeFlowRecommendations() {
  const targets = [
    document.querySelector('cart-recommendations'),
    document.querySelector('product-recommendations'),
  ].filter(Boolean);

  targets.forEach((target) => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          initReviews();
        }
      }
    });
    observer.observe(target, { childList: true, subtree: true });
  });
})();

(function observeCartDrawer() {
  const drawer = document.querySelector("cart-drawer") || document.querySelector(".global-drawer__content");
  if (!drawer) return;

  const observer = new MutationObserver(() => {
    initReviews();
  });

  observer.observe(drawer, { childList: true, subtree: true });
})();
